export var uint16ArrayToString=function(r){return String.fromCharCode.apply(null,new Uint16Array(r.buffer))};